import ApiService from '@/services/ApiService';
import ApiTranslationsService from '@/services/ApiTranslationsService';
import { AxiosResponse } from 'axios';
import { ActionContext } from 'vuex';
import IGlobalState from '@/interfaces/IGlobalState';
import { IModalData } from '@/services/layers/IModalData';
/*eslint-disable */
import EventIconMapperService from '@/services/EventIconMapperService';
import ApiPlanerService from '@/services/ApiPlanerService';
import { ISettingsMap } from '@/interfaces/ISettingsMap';
import { ISettingsParams } from '@/interfaces/ISettingsParams';
import { last } from 'lodash';

const getCurrentTimestampInSeconds = (): number => Math.floor(Date.now() / 1000);

export default {
  updateParkingZones(context: ActionContext<IGlobalState, IGlobalState>) {
    return ApiService.fetchParkingZones()
      .then((res: AxiosResponse<any>) => {
        context.commit('updateParkingZones', res.data);
        context.commit('setLastUpdateParkingZones', getCurrentTimestampInSeconds());
        return res;
      })
      .catch((reason => console.error(reason))); // eslint-disable-line no-console
  },
  updateParkings(context: ActionContext<IGlobalState, IGlobalState>) {
    return ApiService.fetchParkings()
      .then((res: AxiosResponse<any>) => {
        context.commit('updateParkings', res.data);
        context.commit('setLastUpdateParkings', getCurrentTimestampInSeconds());
        return res;
      })
      .catch((reason => console.error(reason))); // eslint-disable-line no-console
  },
  updateParkingMeters(context: ActionContext<IGlobalState, IGlobalState>) {
    return ApiService.fetchParkingMeters()
      .then((res: AxiosResponse<any>) => {
        context.commit('updateParkingMeters', res.data);
        context.commit('setLastUpdateParkingMeters', getCurrentTimestampInSeconds());
        return res;
      })
      .catch((reason => console.error(reason))); // eslint-disable-line no-console
  },
  updateParkingBoards(context: ActionContext<IGlobalState, IGlobalState>) {
    return ApiService.fetchParkingBoards()
      .then((res: AxiosResponse<any>) => {
        context.commit('updateParkingBoards', res.data);
        context.commit('setLastUpdateParkingBoards', getCurrentTimestampInSeconds());
        return res;
      })
      .catch((reason => console.error(reason))); // eslint-disable-line no-console
  },
  updateParkingSpots(context: ActionContext<IGlobalState, IGlobalState>) {
    return ApiService.fetchParkingSpots()
      .then((res: AxiosResponse<any>) => {
        context.commit('updateParkingSpots', res.data);
        context.commit('setLastUpdateParkingSpots', getCurrentTimestampInSeconds());
        return res;
      })
      .catch((reason => console.error(reason))); // eslint-disable-line no-console
  },
  updateParkingGroups(context: ActionContext<IGlobalState, IGlobalState>) {
    return ApiService.fetchParkingGroups()
      .then((res: AxiosResponse<any>) => {
        context.commit('updateParkingGroups', res.data);
        context.commit('setLastUpdateParkingGroups', getCurrentTimestampInSeconds());
        return res;
      })
      .catch((reason => console.error(reason))); // eslint-disable-line no-console
  },
  updateTraffic(context: ActionContext<IGlobalState, IGlobalState>) {
    return ApiService.fetchTraffic()
      .then((res: AxiosResponse<any>) => {
        context.commit('updateTraffic', res.data);
        context.commit('updateTrafficPoints', res.data);
        context.commit('setLastUpdateTraffic', getCurrentTimestampInSeconds());
        return res;
      })
      .catch((reason => console.error(reason))); // eslint-disable-line no-console
  },
  updatePoiLayers(context: ActionContext<IGlobalState, IGlobalState>) {
    return ApiService.fetchPoiCategories()
      .then((res: AxiosResponse<any>) => {
        context.commit('updatePoiLayers', res.data.data);
        context.commit('setLastUpdatePoiLayers', getCurrentTimestampInSeconds());
        return res;
      })
      .catch((reason => console.error(reason))); // eslint-disable-line no-console
  },
  updatePoiPoints(context: ActionContext<any, IGlobalState>) {
    const tempPoi = context.state.settings.mapPoiLayers;
    const filteredCodes = Object.keys(tempPoi).map(key => key);
    const codesStringValue = filteredCodes.join();

    return ApiService.fetchPoiPoints(codesStringValue)
      .then((res: AxiosResponse<any>) => {
        // context.commit('updatePoiLayers'),
        context.commit('updatePoiPoints', res.data);
        context.commit('setLastUpdatePoiPoints', getCurrentTimestampInSeconds());
        return res;
      })
      .catch((reason => console.error(reason))); // eslint-disable-line no-console
  },
  updateSegmentsConfig(context: ActionContext<IGlobalState, IGlobalState>) {
    return ApiService.fetchSegmentsConfig()
      .then((res: AxiosResponse<any>) => {
        if (res.data.data ) {
          context.commit('updateSegmentsConfig', res.data.data);
        }

        return res.data.data;
      })
      .catch((reason => console.error(reason)));
  },
  updateTranslations(context: ActionContext<IGlobalState, IGlobalState>) {
    // return ApiTranslationsService.getAllPortalTranslations()
    return ApiTranslationsService.getAllTranslationsFromFile()
      .then((res: AxiosResponse<any>) => {
        context.commit('updateTranslations', res);

        return res;
      })
      .catch((reason => console.error(reason))); // eslint-disable-line no-console
  },
  
  updateEvents(context: ActionContext<IGlobalState, IGlobalState>) {
    return ApiService.fetchEvents()
      .then((res: AxiosResponse<any>) => {
        context.commit('updateEvents', res.data);
        context.commit('setLastUpdateEvents', getCurrentTimestampInSeconds());
        return res;
      })
      .catch((reason => console.error(reason))); // eslint-disable-line no-console
  },
  updateCurrentWeather(context: ActionContext<IGlobalState, IGlobalState>) {
    return ApiService.fetchCurrentWeather()
      .then((res: AxiosResponse<any>) => {
        context.commit('updateCurrentWeather', res.data);
        return res;
      })
      .catch((reason => console.error(reason))); // eslint-disable-line no-console
  },
  updateOpenWeather(context: ActionContext<IGlobalState, IGlobalState>) {
    return ApiService.fetchOpenWeather()
      .then((res: AxiosResponse<any>) => {
        context.commit('updateOpenWeather', res.data);
        return res;
      })
      .catch((reason => console.error(reason))); // eslint-disable-line no-console
  },
  updateWeatherStations(context: ActionContext<IGlobalState, IGlobalState>) {
    return ApiService.fetchWeatherStationsGroups()
      .then((res: AxiosResponse<any>) => {
        const weatherStationsGroupsFeatures = res.data ? res.data.features : [];
        const weatherStationsToDisplay = weatherStationsGroupsFeatures.map((group: any) => {
            if (group.properties.stations && group.properties.stations.length > 0) {
            return {
              ...group,
              properties: {
                ...group.properties.stations[0],
                //get last status only for the first station in the group 
                last_status: group.properties.last_status.find((obj: any) => obj.stationId === group.properties.stations[0].id),
              },
              geometry: group.properties.stations[0].geometry,
            };
            }
            return group;
        });

        const formattedData = {
          type: 'FeatureCollection',
          features: weatherStationsToDisplay,
        };

        context.commit('updateWeatherStations', formattedData);
        context.commit('setLastUpdateWeatherStations', getCurrentTimestampInSeconds());
        return res;
      })
      .catch((reason => console.error(reason))); // eslint-disable-line no-console
  },
  updateBikeStations(context: ActionContext<IGlobalState, IGlobalState>) {
    return ApiService.fetchBikeStations()
      .then((res: AxiosResponse<any>) => {
        context.commit('updateBikeStations', res.data);
        context.commit('setLastUpdateBikeStations', getCurrentTimestampInSeconds());
        return res;
      })
      .catch((reason => console.error(reason))); 
  },
  updateVmsBoards(context: ActionContext<IGlobalState, IGlobalState>) {
    return ApiService.fetchVmsBoards()
      .then((res: AxiosResponse<any>) => {
        context.commit('updateVmsBoards', res.data);
        context.commit('setLastUpdateVmsBoards', getCurrentTimestampInSeconds());
        return res;
      })
      .catch((reason => console.error(reason))); // eslint-disable-line no-console
  },
  updateRadarBoards(context: ActionContext<IGlobalState, IGlobalState>) {
    return ApiService.fetchRadarBoards()
      .then((res: AxiosResponse<any>) => {
        context.commit('updateRadarBoards', res.data);
        context.commit('setLastUpdateRadarBoards', getCurrentTimestampInSeconds());
        return res;
      })
      .catch((reason => console.error(reason))); // eslint-disable-line no-console
  },
  updateCameras(context: ActionContext<IGlobalState, IGlobalState>) {
    return ApiService.fetchCameras()
      .then((res: AxiosResponse<any>) => {
        context.commit('updateCameras', res.data);
        context.commit('setLastUpdateCameras', getCurrentTimestampInSeconds());
        return res;
      })
      .catch((reason => console.error(reason))); // eslint-disable-line no-console
  },
  updateTrackStartPoints(context: ActionContext<IGlobalState, IGlobalState>) {
    return ApiService.fetchTrackStartPoints()
      .then((res: AxiosResponse<any>) => {
        context.commit('updateTrackStartPoints', res.data);
        return res;
      })
      .catch((reason => console.error(reason))); // eslint-disable-line no-console
  },
  updateTrackEndPoints(context: ActionContext<IGlobalState, IGlobalState>, id: number) {
    return ApiService.fetchTrackEndPoints(id)
      .then((res: AxiosResponse<any>) => {
        context.commit('updateTrackEndPoints', res.data);
        return res;
      })
      .catch((reason => console.error(reason))); // eslint-disable-line no-console
  },
  async updateTrackLines(context: ActionContext<IGlobalState, IGlobalState>, linestringItems: any[]) {
    const trackDataParts: any[] = await Promise.all(
      linestringItems.slice(0, -1).map(async (startPoint, index) => {
        // const endPoint = linestringItems[index + 1];
        // const startPointChain = startPoint.slice().reverse().toString();
        // const endPointChain = endPoint.slice().reverse().toString();

        // try {
        //   const response = await ApiPlanerService.getRoadPlanner(startPointChain, endPointChain);
        //   if (response.data.plan.itineraries) {
        //     return response.data.plan.itineraries[0].legs[0];
        //   }
        // } catch (error) {
        //   console.error(error); // Handle error appropriately
        // }
      })
    );

    // context.commit('updateTrackLines', trackDataParts);
  },
  updateLinks(context: ActionContext<IGlobalState, IGlobalState>) {
    return ApiService.fetchLinks()
      .then((res: AxiosResponse<any>) => {
        context.commit('updateLinks', res.data.data);
        return res;
      })
      .catch((reason => console.error(reason))); // eslint-disable-line no-console
  },
  updateArticles(context: ActionContext<IGlobalState, IGlobalState>) {
    return ApiService.fetchArticles()
      .then((res: AxiosResponse<any>) => {
        context.commit('updateArticles', res.data.data);
        return res;
      })
      .catch((reason => console.error(reason))); // eslint-disable-line no-console
  },
  panAndShowModalForEvent(context: ActionContext<IGlobalState, IGlobalState>, payload: any) {
    // @ts-ignore
    const eventLayers = [
      // @ts-ignore
      ...context.state.leafletLayers.eventsAccidents.GetMarkers(),
      // @ts-ignore
      ...context.state.leafletLayers.eventsBuilding.GetMarkers(),
      // @ts-ignore
      ...context.state.leafletLayers.eventsBlocks.GetMarkers(),
      // @ts-ignore
      ...context.state.leafletLayers.eventsHazard.GetMarkers(),
      // @ts-ignore
      ...context.state.leafletLayers.eventsOther.GetMarkers(),
    ];
    const marker = eventLayers.find(o => o.data.metaData.id === payload.eventId);
    const { metaData } = marker.data;

    const modalData: IModalData = {
      title: metaData.name,
      content: metaData.description,
      navigationPoint: undefined,
      lastUpdate: metaData.updateTime,
      icon: EventIconMapperService(metaData.category.eventCode),
      templateName: 'TemplateModalEvent',
      customClassName: 'modal--event',
      metaData: metaData,
      isIconFullAdress: false,
    };

    context.commit('displayModal', modalData);

    context.state.leafletMapInstance.flyTo({
      lat: marker.position.lat,
      lng: marker.position.lng,
    }, 17);
  },
  setSettingsParams(context: ActionContext<IGlobalState, IGlobalState>) {
    return ApiService.fetchSettingsParams()
      .then((res: AxiosResponse<any>) => {
        const jsonData = res.data.data;
        const formattedData: ISettingsParams = jsonData.reduce((acc: { [x: string]: any; }, { key, value }: any) => {
          acc[key] = value === "1" ? true : value === "0" ? false : value;
          return acc;
        }, {} as ISettingsParams);

        context.commit('setSettingsParams', formattedData);
        return formattedData;
      })
      .catch((reason => console.error(reason))); 
  },
  setSettingsMap(context: ActionContext<IGlobalState, IGlobalState>) {
    return ApiService.fetchSettingsMap()
      .then((res: AxiosResponse<any>) => {
        // static map settings
        const apiData = res.data.data.reduce((acc: Partial<ISettingsMap>, item: { key: keyof ISettingsMap; value: boolean }) => {
          acc[item.key] = item.value;
          return acc;
        }, {});
        // POI map settings
        const apiPoiLayersData = res.data.poiLayers.reduce((acc: Partial<ISettingsMap>, item: { key: keyof ISettingsMap; value: boolean }) => {
          acc[item.key] = item.value;
          return acc;
        }, {});
        // events map settings
        const apiEventsData = res.data.events.reduce((acc: Partial<ISettingsMap>, item: { key: keyof ISettingsMap; value: boolean }) => {
          acc[item.key] = item.value;
          return acc;
        }, {});


        // if (localStorage.getItem('defaultSet') === 'true' || !context.state.settings.map) {
          
        // }
        context.commit('setSettingsMap', apiData);
        context.commit('setSettingsMapEventLayers', apiEventsData);
        context.commit('setSettingsMapPoiLayers', apiPoiLayersData);

        return apiData;
      })
      .catch((reason => console.error(reason))); 
  },
  updateEventCategories(context: ActionContext<IGlobalState, IGlobalState>) {
    return ApiService.fetchEventsCategories()
      .then((res: AxiosResponse<any>) => {
        context.commit('updateEventCategories', res.data.data);
        // context.commit('setLastUpdatePoiLayers', getCurrentTimestampInSeconds());
        return res;
      })
      .catch((reason => console.error(reason))); 

  }
};
